import React, {} from "react";
import { useDropzone } from "react-dropzone";
import ImgUpload from "../../../assets/img/upload.png";
import "./dropzone.css";

const DropZone = ({
  files,
  setFiles,
  onNewFile,
}) => {
  const onDrop = (acceptedFiles) => {
    console.log(acceptedFiles);
    const newFiles = [];
    for (var i = 0; i < acceptedFiles.length; i++) { 
      const file = acceptedFiles[i];
      newFiles.push({
        name: file.name,
        type: file.type,
        size: file.size,
        file: file,
      });
    }
    setFiles([...files, ...newFiles]);
    onNewFile(newFiles);
  };

  const { getRootProps, getInputProps } = useDropzone({ onDrop });

  return (
    <div className="dropzone-wrapper">
      <div
        {...getRootProps()}
        className="dropzone-zone"
        style={{

        }}
      >
        <input {...getInputProps()} />
        <img
          src={ImgUpload}
          className="dropzone-zone-upload-img"
          alt="Upload"
        />          
        <p>Arrossega i deixa anar arxius aquí, o fes clic per seleccionar-los.</p>
      </div>
    </div>    
  );
};

export default DropZone;
